module.exports = __webpack_public_path__ + "static/media/dr jain sir_page-0001.bdc4f724.jpg";